exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video-container[data-v-05b7383e]{position:relative;width:100%;height:45.45455%;min-height:200px;max-height:350px;overflow:hidden}.video[data-v-05b7383e]{position:absolute;z-index:10;top:50%;left:50%;transform:translate(-50%,-50%);background-size:cover;background-position:50%;overflow:hidden}@media screen and (max-width:320px){.VideoBg[data-v-05b7383e]{margin-top:-15px;margin-bottom:-15px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-05b7383e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/Video.vue
// module id = 84
// module chunks = 0